export const ACTIVATION_ERROR_MESSAGES = {
  cohorts:
    'Please ensure at least one Cohort with at least one Visit is added to the Clinical Trial before you proceed with activation.',
  visits:
    'Please ensure at least one Cohort with at least one Visit is added to the Clinical Trial before you proceed with activation.',
  imagingLabels:
    'Please ensure at least one Label is added to the Clinical Trial before you proceed with activation.',
  generalInfo:
    'Please ensure all required fields are filled up before you proceed with activation.',
  forms:
    'eDTF is not assigned.',
  defaultMessage:
    'You cannot activate Clinical Trial until you fill all the necessary data. You can see what you still have to fill out in the tabs',
} as const;
